import { render, staticRenderFns } from "./EpcScore.vue?vue&type=template&id=0eda50b6&"
import script from "./EpcScore.vue?vue&type=script&lang=ts&"
export * from "./EpcScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports